import { MouseEvent, useCallback, useState } from 'react';
import { find } from 'lodash-es';

import { IEnrichedParticipant, IParticipant } from 'src/interfaces/Participant';
import { IRegistration } from 'src/interfaces/Registration';

export function useRegistrationModalState() {
  const [open, setOpen] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState<IParticipant | undefined>();
  const [selectedRegistration, setSelectedRegistration] = useState<IRegistration | undefined>();

  const openForCreate = useCallback((participants: IParticipant[], id?: string, e?: MouseEvent<unknown>) => {
    e?.stopPropagation();
    setSelectedParticipant(find(participants, { id }));
    setSelectedRegistration(undefined);
    setOpen(true);
  }, []);

  const openForCreateParticipant = useCallback((participant: Partial<IParticipant> & { id: string }) => {
    setSelectedParticipant(participant as IParticipant);
    setSelectedRegistration(undefined);
    setOpen(true);
  }, []);

  const openForEdit = useCallback(
    (participants: IEnrichedParticipant[], id?: string, e?: MouseEvent<unknown>) => {
      e?.stopPropagation();
      const participant = find(participants, { id }) as IEnrichedParticipant | undefined;
      if (!participant?.registration) {
        return null;
      }
      setSelectedParticipant(participant);
      setSelectedRegistration(participant.registration);
      setOpen(true);
      return participant;
    },
    [],
  );

  const close = useCallback(() => {
    setSelectedParticipant(undefined);
    setSelectedRegistration(undefined);
    setOpen(false);
  }, []);

  return {
    open,
    selectedParticipant,
    selectedRegistration,
    openForCreate,
    openForCreateParticipant,
    openForEdit,
    close,
  };
}
